import type { IMenu } from '@/services/common';

const access = (initialState: { menus: IMenu[] } | null) => {
  if (initialState === null) {
    return {};
  }
  const menus = initialState?.menus || [];
  return menus.reduce((prev, menu) => {
    if (menu.url === '/doc-library' && !menu.is_hide) {
      prev['D_L'] = true;
    }
    return prev;
  }, {} as Record<'D_L', true>);
};
export const verifyAccess = (initialState: { menus: IMenu[] }, url: string) => {
  if (initialState && initialState.menus.length) {
    return initialState.menus.some((route) => route.url === url);
  }
  return false;
};

export default access;
